import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AdvancedTableSelectPopupIconProps as Props } from './types';

export const AdvancedTableSelectPopupIcon = memo(
  ({ className, name, disabled, size }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('AdvancedTableSelectPopupIcon', className)}
        sx={SX.root}
        name={name}
        size={size ?? 16}
        color="common.black"
        sxx={{ opacity: disabled ? 0.2 : 1 }}
      />
    );
  }
);

AdvancedTableSelectPopupIcon.displayName = 'AdvancedTableSelectPopupIcon';
